import * as z from "zod";
import { attachmentSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemaFormActionValidate = z.object({
  validateOrRefuse: z.enum(["validate", "refused"]),
  comment: zRequiredString("Veuillez saisir un commentaire"),
  attachedFiles: attachmentSchema,
});
